/* @flow */
import CurrentUser from 'auth/CurrentUser';
import Image from 'components/Image.jsx';
import React from 'react';
import UniversalComposeButtonContainer from 'chat/containers/UniversalComposeButtonContainer.jsx';
import GroupStore from 'groups/stores/GroupStore';

import cx from 'classnames';

import './styles/ChatLearnMore.scss';

class ChatLearnMore extends React.Component {
  props: {
    groupCode: string,
  };

  isGroupOwner() {
    const group = GroupStore.getGroupForCode(this.props.groupCode);
    return !!group && group.isOwnedByUser(CurrentUser.getUserId());
  }

  renderSubtext() {
    if (this.isGroupOwner()) {
      return (
        <div>
          Reach individuals and groups by text, app, web, and email.
        </div>
      );
    } else {
      return (
        <div>
          {
            CurrentUser.getUser().isUnderage() ?
              'Never miss a class announcement. Once you turn 13, you can reply to ' +
              'messages you receive.' :
              'Reach your teachers to stay in the loop.'
          }
        </div>
      );
    }
  }

  renderButton() {
    const isGroupOwner = this.isGroupOwner();
    return (
      <UniversalComposeButtonContainer
        className="LearnMore-newChat"
        label="Get started"
        level="secondary"
        size="xsmall"
        hideAnnouncements={!isGroupOwner}
        hideActivities={!isGroupOwner}
      />
    );
  }

  render() {
    return (
      <div className={cx('LearnMore')}>
        <div className="LearnMore-container">
          <Image src={require('assets/images/chat-learnmore-hero.png')} />
          <div className="LearnMore-heading">
            Direct, reliable messaging. Built for education.
          </div>
          <div className="LearnMore-body">{this.renderSubtext()}</div>
          {CurrentUser.getUser().canChat() && this.renderButton()}
        </div>
      </div>
    );
  }
}

export default ChatLearnMore;



// WEBPACK FOOTER //
// ./src/chat/components/ChatLearnMore.jsx